import React, { useEffect, useState } from "react";
import { Row, Col, Button, Input, Progress, Table, Badge, message, Dropdown, Menu, Tooltip } from "antd";
import { PrinterOutlined, ReloadOutlined } from "@ant-design/icons";
import POSLogo from "../../assets/images/NewLogoCW.svg";
import LockIcon from "../../assets/images/lock-icon.svg";
import userIcon from "../../assets/images/userId.svg";
import Online from "../../assets/images/green.svg";
import Offline from "../../assets/images/red.svg";
import SearchIcon from "../../assets/images/searchIcon.svg";
import Swiggy from "../../assets/images/swiggy1.svg";
import Zomato from "../../assets/images/zomato.svg";
import SwiggyBolt from "../../assets/images/swiggyBolt.svg";
import Magicpin from "../../assets/images/magicpin-icon.png";
import RejectIcon from "../../assets/images/Reject.svg";
import AcceptIcon from "../../assets/images/AcceptIcon.svg";
import Axios from "axios";
import {socket} from "../../socket";
import BackIcon from "../../assets/images/backIcon.svg";
import { getSalesHistoryDetails } from "../../utility/salesHistoryUtils";
import { getOAuthHeaders } from "../../constants/oAuthValidation";
import PrintController from "../../lib/printer/printController";
import { useHistory } from "react-router-dom";

const Aggregator = () => {
  const history = useHistory();
  const colorVariable = process.env.REACT_APP_POSBACKGROUND_COLOR;
  const posConfig = JSON.parse(localStorage.getItem("posConfig"));
  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  const [orders, setOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [selectedOrderToPrint, setSelectedOrderToPrint] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedChannel, setSelectedChannel] = useState("All Channels");
  const [timer, setTimer] = useState();
  const [isStatusUpdating, setIsStatusUpdating] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [filteredOrdersState, setFilteredOrdersState] = useState([]);
  const serverUrl = process.env.REACT_APP_serverUrl;
  const authHeaders = getOAuthHeaders();
  const tillValue = JSON.parse(localStorage.getItem("tillValue"));
  const statusDisplayMapping = {
    NEW: "New",
    AK: "Acknowledged",
    FR: "Food Ready",
    DI: "Dispatched",
    CC: "Cancelled",
  };
  const formattedDateTime = `${currentDateTime.toLocaleTimeString()} | ${currentDateTime.toLocaleDateString("en-US", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  })}`;

  const rejectReasons = [
    "item_out_of_stock",
    "store_closed",
    "store_busy",
    "rider_not_available",
    "out_of_delivery_radius",
    "connectivity_issue",
    "total_missmatch",
    "invalid_item",
    "option_out_of_stock",
    "invalid_option",
    "unspecified",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    getSalesHistoryData();

    if (socket) {
      socket.on("order:update", async (data) => {
        console.log("Received order:update:", data);
        getSalesHistoryData();
      });

      socket.on("delivery:update", (data) => {
        console.log("Received delivery:update:", data);
        getSalesHistoryData();
      });
    }

    return () => {
      if (socket) {
        socket.off("order:update");
        socket.off("delivery:update");
      }
    };
  }, []);

  useEffect(() => {
    if (searchValue) {
      const filtered = orders.filter((order) =>
        order.orderNo.toLowerCase().includes(searchValue.toLowerCase())
      );
      setFilteredOrdersState(filtered);
    } else {
      setFilteredOrdersState(orders);
    }
  }, [searchValue, orders]);

  // useEffect(() => {
  //   let countdown;
  //   if (selectedOrder && selectedOrder.status === "NEW" && timer > 0) {
  //     countdown = setInterval(() => {
  //       setTimer((prev) => {
  //         if (prev <= 1) {
  //           clearInterval(countdown);
  //           updateOrderStatus(selectedOrder.sOrderID, "Acknowledged", true);
  //           return 0;
  //         }
  //         return prev - 1;
  //       });
  //     }, 1000);
  //   }
  //   return () => {
  //     if (countdown) clearInterval(countdown);
  //   };
  // }, [selectedOrder, timer]);

  // useEffect(() => {
  //   if (selectedOrder && selectedOrder.status === "NEW") {
  //     setTimer(30);
  //   }
  // }, [selectedOrder?.sOrderID]);

  const getSalesHistoryData = async () => {
    let setAuthTokens = authHeaders.access_token;
    const sortOptions = {
      documentno: "desc",
      dateordered: "desc",
      customer: null,
      totalAmount: null,
    };
    const filteredSortOptions = Object.fromEntries(
      Object.entries(sortOptions).filter(([key, value]) => value !== null)
    );
    const sortData = JSON.stringify(filteredSortOptions).replace(/"/g, '\\"');
    setLoading(true);
    try {
      const response = await Axios({
        url: serverUrl,
        method: "POST",
        data: {
          query: `query {salesHistory(
                      q: null,
                      filter_by: null,
                      startRow: "0",
                      endRow: "100",
                      sort_by: "${sortData}",
                      tillId: "${tillValue.cwr_till_id}"
                      aggregator: "Y"
                    ) {
                    sOrderID
                    documentno
                    dateordered
                    totalQty
                    orderTime
                    grosstotal
                    layAway
                    isReturn
                    ofdStatus
                    saleType {
                        cwrSaletypeId
                        name
                        value
                      }
                    cwrB2cCustomer {
                      name
                      }
                    cwrTill {
                      till
                    }
                  }         
                  }`,
        },
        headers: {
          "Content-Type": "Application/json",
          Authorization: `${setAuthTokens}`,
        },
      });

      const salesDataArray = response?.data?.data?.salesHistory || [];
      if (salesDataArray.length > 0) {
        const newOrders = salesDataArray
          .filter(
            (salesData) =>
              salesData.ofdStatus === "NEW" ||
              salesData.ofdStatus === "AK" ||
              salesData.ofdStatus === "FR" ||
              salesData.ofdStatus === "DI"
          )
          .map((salesData) => ({
            sOrderID: salesData.sOrderID,
            orderNo: salesData.documentno,
            orderTime: salesData.orderTime,
            channel: salesData.saleType?.name || "Unknown",
            status: salesData.ofdStatus || "NEW",
            amount: salesData.grosstotal,
          }));
        setOrders(newOrders);
        setFilteredOrdersState(newOrders);
        if (!selectedOrder && newOrders.length > 0) {
          const orderDetails = await getSalesHistoryDetails(newOrders[0].sOrderID, newOrders[0].status, false);
          if (orderDetails) {
            setSelectedOrder(orderDetails);
          }
        } else if (selectedOrder && !isStatusUpdating) {
          const updatedOrder = newOrders.find(
            (order) => order.sOrderID === selectedOrder.sOrderID
          );
          if (updatedOrder && updatedOrder.status !== selectedOrder.status) {
            setSelectedOrder((prev) => ({ ...prev, status: updatedOrder.status }));
          }
        }
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching order history:", error);
      setLoading(false);
    }
  };

  const updateOrderStatus = async (sOrderID, newStatus, isAuto = false, reasonCode = null) => {
    let setAuthTokens = authHeaders.access_token;
    const statusMapping = {
      Acknowledged: "AK",
      Cancelled: "CC",
      "Food Ready": "FR",
      Dispatched: "DI",
    };
    const statusCode = statusMapping[newStatus] || newStatus;
    setLoading(true);
    setIsStatusUpdating(true);
    try {
      const response = await Axios({
        url: serverUrl,
        method: "POST",
        data: {
          query: `mutation {
            upsertOfdOrderStatus(order: [{
              sOrderID: "${sOrderID}"
              ofdStatus: "${statusCode}"
              isOnline:"N"
              ${reasonCode ? `reasonCode: "${reasonCode}"` : ""}
            }]) { 
              status
              message   
            }
          }`,
        },
        headers: {
          "Content-Type": "Application/json",
          Authorization: `${setAuthTokens}`,
        },
      });

      const result = response?.data?.data?.upsertOfdOrderStatus;
      if (result?.status === "200") {
        if (isAuto) {
          message.success("Order automatically accepted after timeout!");
        } else {
          message.success(result?.message);
        }
        await getSalesHistoryData();

        if (selectedOrder?.sOrderID === sOrderID) {
          setSelectedOrder((prev) => ({ ...prev, status: statusCode }));
          if (statusCode !== "CC") {
            const orderDetails = await getSalesHistoryDetails(sOrderID, statusCode, statusCode === "AK" ? true : false);
            if (orderDetails) {
              setSelectedOrder(orderDetails);
            }
          }
        }

        if (statusCode === "CC" && selectedOrder?.sOrderID === sOrderID) {
          setSelectedOrder(null);
        }
      } else {
        console.error("Status update failed:", result?.message);
        message.error("Failed to update order status.");
      }
    } catch (error) {
      console.error("Error updating order status:", error);
      message.error("Error updating order status.");
    } finally {
      setLoading(false);
      setIsStatusUpdating(false);
    }
  };

  const syncOrder = async (order) => {
    let setAuthTokens = authHeaders.access_token;
    const tillData = JSON.parse(localStorage.getItem("tillData"));
    const orderJson = {
      sOrderID: order.sOrderID,
      cSClientID: tillData.tillAccess.csClientId,
      cSBunitID: tillData.tillAccess.csBunit.csBunitId,
      created: order.orderTime,
      createdby: order.createdBy,
      updated: order.orderTime,
      updatedby: order.createdBy,
      csDoctypeId: tillData.tillAccess.csBunit.cwrCsDoctypeId,
      sCustomerId: tillData.tillAccess.csBunit.b2cCustomer.sCustomer.sCustomerID,
      sCustomerBillingId: tillData.tillAccess.csBunit.customerAddress.sCustomerAddressID,
      sCustomerShippingId: tillData.tillAccess.csBunit.customerAddress.sCustomerAddressID,
      sPricelistId: tillData.tillAccess.csBunit.cwrSpricelistId,
      documentno: order.orderNo,
      dateordered: order.orderTime,
      datepromised: order.orderTime,
      csPaymenttermID: null,
      finPaymentmethodId: order.paymentMode ? order.paymentMode : null,
      csCurrencyId: tillData?.tillAccess?.csBunit?.currencies[0]?.csCurrencyId || "",
      mWarehouseId: tillData.tillAccess.csBunit.mWarehouse.mWarehouseID,
      cwrLongitude: "",
      cwrLatitude: "",
      csUserId: tillData.tillAccess.csUserId,
      cwrB2cCustomerId: order.customer?.cwrCustomerId
        ? order.customer?.cwrCustomerId
        : order.customer?.b2cCustomerId,
      orderreference: "",
      cwrPayref: "",
      cwrPayremarks: "",
      description: order?.description || "",
      storeDailyOpsTillid: localStorage.getItem("storeDailyOpsTillid"),
      cwrTillId: tillData.tillAccess.cwrTill.cwrTillID,
      redemption: 0,
      accumulation: 0,
      redeemRefId: null,
      roundoff: parseFloat(order?.roundOff?.toFixed(2)) || 0,
      cwrProductQty: order?.totalQty || 0,
      cwrProductCount: order?.totalQty || 0,
      ofdStatus: "Dispatched",
      ofdIspaid: "Y",
      posLoyaltyCalculation: posConfig?.disablePOSLoyaltyCalculation,
      mPricingruleId: order?.mPricingruleId ?? null,
      cwrSaletypeId: order.channel === "Swiggy" ? "SWIGGY" : order.channel === "Zomato" ? "ZOMATO" : "",
      salesRepId: order?.salesRepId || null,
      discAmount: parseFloat(order.discount?.toFixed(2)) || 0,
      creditAmount: order?.creditAmount,
      metaData: {},
      giftCard: [],
      pricingCoupon: [
        {
          mPricingCouponId: null,
          redemptionCount: null,
          referenceId: null,
        },
      ],
      orderTotal: parseFloat(order.amount?.toFixed(2)) || 0,
      nettotal: parseFloat((order.amount - order.tax)?.toFixed(2)) || 0,
      taxamt: parseFloat(order.tax?.toFixed(2)) || 0,
      isReturn: "N",
      sOrderReturnId: order?.items?.[0]?.sOrderReturnId || null,
      layAway: order.layAway || null,
      payments: order.paymentMode
        ? [{ paymentMethod: order.paymentMode, amount: order.amount }]
        : [],
      tax: order.tax ? [{ amount: order.tax }] : [],
      line: order.items?.map((item) => ({
        productName: item.name,
        qty: item.quantity,
        price: item.price,
        discount: item.discount,
        tax: item.tax,
      })) || [],
    };

    const stringifiedData = JSON.stringify(orderJson);
    const newStringRequest = JSON.stringify(stringifiedData.replace(/\\"/g, '\\"'));

    try {
      const response = await Axios({
        url: serverUrl,
        method: "POST",
        data: {
          query: `mutation {
            posOrderProcessor1(
              tillId: "${tillData.tillAccess.cwrTill.cwrTillID}", 
              orderId: "${order.sOrderID}", 
              documentNo: "${order.orderNo}", 
              orderJson: ${newStringRequest}
            ) {
              documentno
              status
              message
            }
          }`,
        },
        headers: {
          "Content-Type": "Application/json",
          Authorization: `${setAuthTokens}`,
        },
      });

      const result = response?.data?.data?.posOrderProcessor1;
      if (result?.status === "200") {
        message.success(`Order ${result.documentno} synced successfully!`);
      } else {
        console.error("Sync failed:", result?.message);
        message.error("Failed to sync order to backend.");
      }
    } catch (error) {
      console.error("Error syncing order:", error);
      message.error("Error syncing order to backend.");
    }
  };

  const filteredOrders =
    selectedChannel === "All Channels"
      ? filteredOrdersState
      : filteredOrdersState.filter(
        (order) => order.channel.toLowerCase() === selectedChannel.toLowerCase()
      );

  const newOrders = filteredOrders.filter((order) => order.status === "NEW");
  const preparingOrders = filteredOrders.filter((order) => order.status === "AK");
  const readyOrders = filteredOrders.filter((order) => order.status === "FR" || order.status === "DI");

  const getTableData = (order) => {
    if (!order || !order.items) return [];
    return order.items.map((item, index) => ({
      key: index.toString(),
      product: (
        <div>
          <div>{item?.name}</div>
          {item.addons.length > 0 && (
            <div style={{ marginLeft: "20px", color: "#666" }}>
              {item.addons.map((addon, idx) => (
                <div key={idx}>
                  - {addon.name} (Qty: {addon.qty}, ₹{addon.price})
                </div>
              ))}
            </div>
          )}
        </div>
      ),
      grossstd: item.quantity,
      qty: item.discount || "0.00",
      remainingQty: item.tax || "0.00",
      linenet: `₹${item.linenet}`,
      netValue: `₹${item.price}`,
    }));
  };

  const handleOrderClick = (order) => {
    // const channelId = order.saleType?.cwrSaletypeId || "";
    getSalesHistoryDetails(order.sOrderID, order.status, false, null, true).then((data) => {
      if (data) {
        const { detailedOrder, transformedOrder } = data;
        if (detailedOrder) {
          setSelectedOrder(detailedOrder);
          setSelectedOrderToPrint(transformedOrder);
        }
      }
    });
  };

  const handleChannelClick = (channel) => {
    setSelectedChannel(channel);
  };

  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
  };

  const handleAccept = async () => {
    if (selectedOrder) {
      await updateOrderStatus(selectedOrder.sOrderID, "Acknowledged");
    }
  };

  const handleReject = (reason) => {
    if (selectedOrder) {
      updateOrderStatus(selectedOrder.sOrderID, "Cancelled", false, reason);
    }
  };

  const handleMarkAsReady = () => {
    if (selectedOrder) {
      updateOrderStatus(selectedOrder.sOrderID, "Food Ready");
    }
  };

  const handleComplete = async () => {
    if (selectedOrder) {
      await updateOrderStatus(selectedOrder.sOrderID, "Dispatched");
      await syncOrder(selectedOrder);
    }
  };

  const handlePrint = () => {
    if (selectedOrder) {
      try {
        PrintController(selectedOrderToPrint);
      } catch (error) {
        console.error("Error printing order:", error);
        message.error("Failed to print order");
      }
    }
  };

  const rejectMenu = (
    <Menu onClick={({ key }) => handleReject(key)}>
      {rejectReasons.map((reason) => (
        <Menu.Item key={reason}>
          {reason.replace(/_/g, " ").toUpperCase()}
        </Menu.Item>
      ))}
    </Menu>
  );

  const getUniqueChannels = () => {
    const channels = [...new Set(orders.map((order) => order.channel))];
    return channels.filter((channel) => channel && channel !== "Unknown");
  };

  const channelIcons = {
    swiggy: Swiggy,
    zomato: Zomato,
    magicpin: Magicpin,
    swiggybolt: SwiggyBolt,
  };

  const renderButtons = () => {
    if (!selectedOrder) return null;

    switch (selectedOrder.status) {
      case "NEW":
        return (
          <>
            <Dropdown overlay={rejectMenu} trigger={["click"]}>
              <Button
                style={{
                  height: "5.5vh",
                  color: "#2F3856",
                  borderRadius: "7px",
                  width: "20%",
                  marginRight: "1vw",
                }}
                disabled={loading}
              >
                <img style={{ height: "2.5vh", marginRight: "0.4vw" }} src={RejectIcon} /> Reject
              </Button>
            </Dropdown>
            <Button
              onClick={handleAccept}
              style={{
                height: "5.5vh",
                backgroundColor: "#2F3856",
                color: "#fff",
                borderRadius: "7px",
                width: "20%",
              }}
              disabled={loading}
            >
              <img style={{ height: "2.5vh", marginRight: "0.4vw" }} src={AcceptIcon} /> Accept
            </Button>
          </>
        );
      case "AK":
        return (
          <Button
            onClick={handleMarkAsReady}
            style={{
              height: "5.5vh",
              backgroundColor: "#E99013",
              color: "#fff",
              borderRadius: "7px",
              width: "20%",
            }}
            disabled={loading}
          >
            Mark as Ready
          </Button>
        );
      case "FR":
        return (
          <Button
            onClick={handleComplete}
            style={{
              height: "5.5vh",
              backgroundColor: "#008000",
              color: "#fff",
              borderRadius: "7px",
              width: "20%",
            }}
            disabled={loading}
          >
            Dispatch
          </Button>
        );
      case "DI":
        return null;
      default:
        return null;
    }
  };

  return (
    <div style={{ background: colorVariable || "#f3f4f9", height: "100vh", overflow: "hidden" }}>
      <Row
        style={{
          padding: "0.5% 0",
          height: "7.5vh",
          alignItems: "center",
          fontSize: "1vw",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Col onClick={() => history.push("/pos")} style={{ cursor: "pointer" }} span={1}>
          <img src={BackIcon} style={{ paddingLeft: "1rem", height: "2vw" }} />
        </Col>
        <Col
          span={3}
          onDoubleClick={() => history.push("/pos")}
          style={{ cursor: "pointer" }}
        >
          <img src={POSLogo} style={{ height: "2.5vw", paddingLeft: "0.4vw" }} />
        </Col>
        <Col
          span={9}
          style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}
        >
          {/* No Reload Button here */}
        </Col>
        <Col
          span={6}
          style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}
        >
          <span
            style={{
              fontFamily: "Inter",
              fontWeight: 500,
              fontSize: "1em",
              color: "#929098",
            }}
          >
            {formattedDateTime}
          </span>
        </Col>
        <Col
          span={5}
          style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}
        >
          <img
            onClick={() => { }}
            src={LockIcon}
            style={{ height: "3vh", cursor: "pointer", marginRight: "0.7rem" }}
          />
          <div
            style={{
              display: "flex",
              alignItems: "end",
              justifyContent: "center",
              padding: "0.5vw",
              border: "1px solid #3C424B",
              borderRadius: "50%",
            }}
          >
            <img src={userIcon} style={{ height: "2.7vh" }} />
          </div>
          <div style={{ marginLeft: "1vw", display: "flex", flexDirection: "column" }}>
            <span
              style={{
                color: "#0F0718",
                fontSize: "1em",
                fontFamily: "Inter",
                fontWeight: "500",
                wordWrap: "break-word",
              }}
            >
              {JSON.parse(localStorage.getItem("userData")).user}
            </span>
            <span
              style={{
                color: "#0F0718",
                fontSize: "0.8em",
                fontFamily: "Inter",
                fontWeight: "500",
                wordWrap: "break-word",
              }}
            >
              Till ID : {tillValue.name}
            </span>
          </div>
          <div style={{ marginLeft: "3%" }}>
            <img
              src={Online}
              style={{
                display: !navigator.onLine && "none",
                height: "2.5vh",
                cursor: "pointer",
                paddingBottom: "0.5vh",
              }}
            />
            <img
              src={Offline}
              style={{
                display: navigator.onLine && "none",
                height: "2.5vh",
                cursor: "pointer",
                paddingBottom: "0.5vh",
              }}
            />
          </div>
        </Col>
      </Row>

      <Row style={{ fontSize: "1vw", padding: "0 1.2vw", alignItems: "center" }}>
        <Col span={15}>
          <Input
            placeholder="Search for Orders by Document Number"
            id="sm-product-search"
            className="productSearch-sm"
            style={{
              borderRadius: "12px",
              padding: "0.8vh 0.8vw",
              borderColor: "#fff",
              height: "5.5vh",
              borderRadius: "7px",
            }}
            prefix={<img src={SearchIcon} alt="" />}
            value={searchValue}
            onChange={handleSearchChange}
          />
        </Col>
      </Row>

      <Row
        style={{ marginTop: "1.2vh", fontSize: "1vw", padding: "0 1.2vw" }}
        gutter={[8, 8]}
        align="middle"
      >
        <Col>
          <Button
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minWidth: "8vw",
              borderRadius: "20px",
              color: "#fff",
              height: "5.5vh",
              backgroundColor: "#2F3856",
              fontWeight: 500,
              fontFamily: "Inter",
              padding: "0 1vw",
              fontSize: "1em",
            }}
            onClick={() => handleChannelClick("All Channels")}
          >
            All Channels
          </Button>
        </Col>
        {getUniqueChannels().map((channel) => (
          <Col key={channel}>
            <Button
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "fit-content",
                borderRadius: "20px",
                height: "5.5vh",
                fontWeight: 500,
                fontFamily: "Inter",
                border: "none",
                backgroundColor: selectedChannel === channel ? "#2F3856" : "#fff",
                padding: "0 0.8vw",
                gap: "0.3vw",
                color: selectedChannel === channel ? "#fff" : "#929098",
                fontSize: "1em",
              }}
              onClick={() => handleChannelClick(channel)}
            >
              <img
                src={channelIcons[channel?.toLowerCase()] || ""}
                style={{
                  height: channel === "Zomato" ? "3vh" : "4vh",
                  width: "auto",
                  objectFit: "contain",
                }}
              />
              {channel}
            </Button>
          </Col>
        ))}
        <Col
          style={{
            flex: 1,
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <Tooltip title="Refresh orders">
            <Button
              onClick={getSalesHistoryData}
              style={{
                height: "5.5vh",
                width: "4vw",
                backgroundColor: "#2F3856",
                color: "#fff",
                borderRadius: "7px",
              }}
              disabled={loading}
              icon={<ReloadOutlined />}
            />
          </Tooltip>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: "1.5vh", fontSize: "1vw", padding: "0 1.2vw" }}>
        <Col span={7}>
          <div
            style={{
              height: "22.5vh",
              borderRadius: "7px",
              backgroundColor: "#fff",
              padding: "0 15px 0 10px",
              marginBottom: "1vh",
              overflow: "auto",
            }}
          >
            <Row style={{ color: "#0F0718", fontSize: "1em", fontWeight: 500, paddingTop: "1vh" }}>
              New Orders ({newOrders.length})
            </Row>
            {newOrders.map((order) => (
              <div key={order.orderNo} onClick={() => handleOrderClick(order)} style={{ cursor: "pointer" }}>
                <Row style={{ display: "flex", alignItems: "center" }}>
                  <Col span={3}>
                    <img
                      style={{ height: "7vh", width: "4vw" }}
                      src={channelIcons[order.channel?.toLowerCase()] || ""}
                    />
                  </Col>
                  <Col span={12} style={{ display: "flex", alignItems: "center", paddingLeft: "1vw" }}>
                    <div>
                      <p style={{ fontWeight: 500, color: "#0F0718", fontSize: "1.1em", marginBottom: 0 }}>
                        {order.orderNo}
                      </p>
                      <p style={{ fontWeight: 400, color: "#929098", fontSize: "0.8em", marginBottom: 0 }}>
                        {order.orderTime}
                      </p>
                    </div>
                  </Col>
                  <Col span={9} style={{ textAlign: "right" }}>
                    <Badge color="#4F23F1" />
                    <span style={{ fontSize: "1em", color: "#929098" }}>New</span>
                    <p style={{ fontWeight: 600, color: "#2F3856", fontSize: "1.25em", marginBottom: 0 }}>
                      ₹{order.amount}
                    </p>
                  </Col>
                </Row>
                <hr style={{ width: "98%", color: "#C5C7C9", margin: "0.6vh" }} />
              </div>
            ))}
          </div>

          <div
            style={{
              height: "22.5vh",
              borderRadius: "7px",
              backgroundColor: "#fff",
              padding: "0 15px 0 10px",
              marginBottom: "1vh",
              overflow: "auto",
            }}
          >
            <Row style={{ color: "#0F0718", fontSize: "1em", fontWeight: 500, paddingTop: "1vh" }}>
              Preparing ({preparingOrders.length})
            </Row>
            {preparingOrders.map((order) => (
              <div key={order.orderNo} onClick={() => handleOrderClick(order)} style={{ cursor: "pointer" }}>
                <Row style={{ display: "flex", alignItems: "center" }}>
                  <Col span={3}>
                    <img style={{ height: "7vh", width: "4vw" }} src={channelIcons[order.channel?.toLowerCase()] || ""} />
                  </Col>
                  <Col span={12} style={{ display: "flex", alignItems: "center", paddingLeft: "1vw" }}>
                    <div>
                      <p style={{ fontWeight: 500, color: "#0F0718", fontSize: "1.1em", marginBottom: 0 }}>
                        {order.orderNo}
                      </p>
                      <p style={{ fontWeight: 400, color: "#929098", fontSize: "0.8em", marginBottom: 0 }}>
                        {order.orderTime}
                      </p>
                    </div>
                  </Col>
                  <Col span={9} style={{ textAlign: "right" }}>
                    <Badge color="#E99013" />
                    <span style={{ fontSize: "1em", color: "#929098" }}>Acknowledged</span>
                    <p style={{ fontWeight: 600, color: "#2F3856", fontSize: "1.25em", marginBottom: 0 }}>
                      ₹{order.amount}
                    </p>
                  </Col>
                </Row>
                <hr style={{ width: "98%", color: "#C5C7C9", margin: "0.6vh" }} />
              </div>
            ))}
          </div>

          <div
            style={{
              height: "31.2vh",
              borderRadius: "7px",
              backgroundColor: "#fff",
              padding: "0 15px 0 10px",
              overflow: "auto",
            }}
          >
            <Row style={{ color: "#0F0718", fontSize: "1em", fontWeight: 500, paddingTop: "1vh" }}>
              Ready to Dispatch/Dispatched ({readyOrders.length})
            </Row>
            {readyOrders.map((order) => (
              <div key={order.orderNo} onClick={() => handleOrderClick(order)} style={{ cursor: "pointer" }}>
                <Row style={{ display: "flex", alignItems: "center" }}>
                  <Col span={3}>
                    <img style={{ height: "7vh", width: "4vw" }} src={channelIcons[order.channel?.toLowerCase()] || ""} />
                  </Col>
                  <Col span={12} style={{ display: "flex", alignItems: "center", paddingLeft: "1vw" }}>
                    <div>
                      <p style={{ fontWeight: 500, color: "#0F0718", fontSize: "1.1em", marginBottom: 0 }}>
                        {order.orderNo}
                      </p>
                      <p style={{ fontWeight: 400, color: "#929098", fontSize: "0.8em", marginBottom: 0 }}>
                        {order.orderTime}
                      </p>
                    </div>
                  </Col>
                  <Col span={9} style={{ textAlign: "right" }}>
                    <Badge color={order.status === "FR" ? "#008000" : "#4F23F1"} />
                    <span style={{ fontSize: "1em", color: "#929098" }}>
                      {statusDisplayMapping[order.status]}
                    </span>
                    <p style={{ fontWeight: 600, color: "#2F3856", fontSize: "1.25em", marginBottom: 0 }}>
                      ₹{order.amount}
                    </p>
                  </Col>
                </Row>
                <hr style={{ width: "98%", color: "#C5C7C9", margin: "0.6vh" }} />
              </div>
            ))}
          </div>
        </Col>

        <Col span={17}>
          {selectedOrder ? (
            <div
              style={{
                backgroundColor: "#fff",
                height: "78vh",
                borderRadius: "7px",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
              }}
            >
              <div style={{ padding: "2vh 1.2vw 0 1.2vw" }}>
                <Row>
                  <Col span={12} style={{ display: "flex", alignItems: "center" }}>
                    <img
                      style={{ height: "4.5vh" }}
                      src={
                        selectedOrder.channel.toLowerCase() === "swiggy"
                          ? selectedOrder?.metaData?.find(md => md.key === "Instant Order")?.value === "true"
                            ? SwiggyBolt
                            : Swiggy
                          : selectedOrder.channel.toLowerCase() === "zomato"
                            ? selectedOrder?.metaData?.find(md => md.key === "Instant Order")?.value === "true"
                              ? Zomato
                              : Zomato
                            : null
                      }
                    />
                    <p
                      style={{
                        color: "#0F0718",
                        fontSize: "1.5em",
                        fontWeight: 600,
                        marginBottom: 0,
                        paddingLeft: "0.8vw",
                      }}
                    >
                      Order No: {selectedOrder.orderNo || "N/A"}
                    </p>
                  </Col>
                  <Col span={12} style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                    <Tooltip title="Print Order">
                      <Button
                        onClick={handlePrint}
                        style={{
                          height: "4vh",
                          width: "2vw",
                          // backgroundColor: "#2F3856",
                          color: "#2F3856",
                          borderRadius: "7px",
                          border: "1px solid #2F3856",
                          marginRight: "1vw",
                        }}
                        icon={<PrinterOutlined />}
                      />
                    </Tooltip>
                    {/* {selectedOrder.status === "NEW" && (
                      <>
                        <p
                          style={{
                            marginBottom: 0,
                            fontSize: "0.9em",
                            color: "#0F0718",
                            fontWeight: 400,
                            paddingRight: "0.6vw",
                          }}
                        >
                          Accept Order ({timer}s)
                        </p>
                        <Progress
                          type="circle"
                          percent={(timer / 30) * 100}
                          width={45}
                          strokeWidth={7}
                          strokeColor="#FF5D0D"
                          format={() => (
                            <div style={{ textAlign: "center" }}>
                              <p style={{ margin: 0, fontSize: "1.2em", fontWeight: 600, color: "#FF5D0D" }}>
                                {timer}
                              </p>
                              <p style={{ margin: 0, fontSize: "0.7em", color: "#FF5D0D" }}>Sec</p>
                            </div>
                          )}
                        />
                      </>
                    )} */}
                  </Col>
                </Row>
              </div>

              <div
                style={{
                  flex: 1,
                  overflowY: "auto",
                  padding: "0 1.2vw",
                }}
              >
                <Row>
                  <Col span={8}>
                    <Row align="middle">
                      <Col
                        span={9}
                        style={{ fontWeight: 400, fontSize: "0.9em", color: "#0F0718", fontFamily: "Inter" }}
                      >
                        Channel
                      </Col>
                      <Col
                        span={15}
                        style={{
                          fontWeight: 500,
                          fontSize: "1.1em",
                          color: "#0F0718",
                          fontFamily: "Inter",
                        }}
                      >
                        {selectedOrder.channel || "N/A"}
                      </Col>
                    </Row>
                    {selectedOrder?.externalId && (
                      <Row align="middle" style={{ marginTop: "1vh" }}>
                        <Col
                          span={9}
                          style={{ fontWeight: 400, fontSize: "0.9em", color: "#0F0718", fontFamily: "Inter" }}
                        >
                          Order Id
                        </Col>
                        <Col
                          span={15}
                          style={{
                            fontWeight: 500,
                            fontSize: "1.1em",
                            color: "#0F0718",
                            fontFamily: "Inter",
                          }}
                        >
                          {selectedOrder.externalId || ""}
                        </Col>
                      </Row>
                    )}
                    <Row style={{ marginTop: "1vh" }} align="middle">
                      <Col
                        span={9}
                        style={{ fontWeight: 400, fontSize: "0.9em", color: "#0F0718", fontFamily: "Inter" }}
                      >
                        Status
                      </Col>
                      <Col
                        span={15}
                        style={{
                          fontWeight: 500,
                          fontSize: "0.8em",
                          color: "#0F0718",
                          fontFamily: "Inter",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <p
                          style={{
                            backgroundColor: "#4F23F1",
                            color: "#fff",
                            borderRadius: "3px",
                            padding: "3px 8px",
                            marginBottom: 0,
                          }}
                        >
                          {statusDisplayMapping[selectedOrder.status] || selectedOrder.status || "N/A"}
                        </p>
                      </Col>
                    </Row>
                    <Row style={{ marginTop: "1vh" }} align="middle">
                      <Col
                        span={9}
                        style={{ fontWeight: 400, fontSize: "0.9em", color: "#0F0718", fontFamily: "Inter" }}
                      >
                        Order Amount
                      </Col>
                      <Col
                        span={15}
                        style={{
                          fontWeight: 500,
                          fontSize: "1.1em",
                          color: "#0F0718",
                          fontFamily: "Inter",
                        }}
                      >
                        ₹{selectedOrder.amount || "0"}
                      </Col>
                    </Row>
                    <Row style={{ marginTop: "1vh" }} align="middle">
                      <Col
                        span={9}
                        style={{ fontWeight: 400, fontSize: "0.9em", color: "#0F0718", fontFamily: "Inter" }}
                      >
                        Tax
                      </Col>
                      <Col
                        span={15}
                        style={{
                          fontWeight: 500,
                          fontSize: "1.1em",
                          color: "#0F0718",
                          fontFamily: "Inter",
                        }}
                      >
                        ₹{selectedOrder.tax || "0"}
                      </Col>
                    </Row>
                    <Row style={{ marginTop: "1vh" }} align="middle">
                      <Col
                        span={9}
                        style={{ fontWeight: 400, fontSize: "0.9em", color: "#0F0718", fontFamily: "Inter" }}
                      >
                        Discount
                      </Col>
                      <Col
                        span={15}
                        style={{
                          fontWeight: 500,
                          fontSize: "1.1em",
                          color: "#0F0718",
                          fontFamily: "Inter",
                        }}
                      >
                        ₹{selectedOrder.discount || "0"}
                      </Col>
                    </Row>
                  </Col>
                  <Col span={8}>
                    <Row>
                      <Col
                        span={24}
                        style={{ fontWeight: 500, fontSize: "1.1em", color: "#0F0718", fontFamily: "Inter" }}
                      >
                        {selectedOrder.customerName || "N/A"}
                      </Col>
                    </Row>
                    <Row style={{ marginTop: "1vh" }}>
                      <Col
                        span={24}
                        style={{ fontWeight: 600, fontSize: "1.1em", color: "#2F3856", fontFamily: "Inter" }}
                      >
                        {selectedOrder.customerPhone || "N/A"}
                      </Col>
                    </Row>
                    <Row style={{ marginTop: "1vh" }}>
                      <Col
                        span={24}
                        style={{ fontWeight: 400, fontSize: "0.9em", color: "#0F0718", fontFamily: "Inter" }}
                      >
                        {selectedOrder.customerEmail || "N/A"}
                      </Col>
                    </Row>
                    <Row style={{ marginTop: "1vh" }}>
                      <Col
                        span={24}
                        style={{ fontWeight: 400, fontSize: "0.9em", color: "#0F0718", fontFamily: "Inter" }}
                      >
                        {selectedOrder.customerAddress || "N/A"}
                      </Col>
                    </Row>
                    <Row style={{ marginTop: "1vh" }}>
                      <Col
                        span={24}
                        style={{ fontWeight: 400, fontSize: "0.9em", color: "#0F0718", fontFamily: "Inter" }}
                      >
                        {selectedOrder.orderTime || "N/A"}
                      </Col>
                    </Row>
                  </Col>
                  <Col span={8}>
                    {selectedOrder?.metaData && (
                      <>
                        {selectedOrder.metaData.some((md) => md.key === "Charges") && (
                          <>
                            <Row>
                              <Col
                                span={24}
                                style={{
                                  fontWeight: 600,
                                  fontSize: "1.2em",
                                  color: "#2F3856",
                                  fontFamily: "Inter",
                                }}
                              >
                                Packaging Charges
                              </Col>
                            </Row>
                            {(() => {
                              const chargesData = selectedOrder.metaData.find((md) => md.key === "Charges");
                              try {
                                const parsedCharges = JSON.parse(chargesData.value);
                                return parsedCharges.map((charge, index) => (
                                  <Row key={index} style={{ marginTop: "1vh" }}>
                                    <Col
                                      span={9}
                                      style={{
                                        fontWeight: 400,
                                        fontSize: "0.9em",
                                        color: "#0F0718",
                                        fontFamily: "Inter",
                                      }}
                                    >
                                      {charge.title}
                                    </Col>
                                    <Col
                                      span={15}
                                      style={{
                                        fontWeight: 500,
                                        fontSize: "1.1em",
                                        color: "#0F0718",
                                        fontFamily: "Inter",
                                      }}
                                    >
                                      ₹{charge.value}
                                    </Col>
                                  </Row>
                                ));
                              } catch (e) {
                                console.error("Failed to parse charges metadata:", e);
                                return null;
                              }
                            })()}
                          </>
                        )}

                        {selectedOrder.metaData.some((md) => md.key === "Rider Status") && (
                          <>
                            <Row style={{ marginTop: "2vh" }}>
                              <Col
                                span={24}
                                style={{
                                  fontWeight: 600,
                                  fontSize: "1.2em",
                                  color: "#2F3856",
                                  fontFamily: "Inter",
                                }}
                              >
                                Delivery Info
                              </Col>
                            </Row>
                            {(() => {
                              const riderData = selectedOrder.metaData.find((md) => md.key === "Rider Status");
                              try {
                                const parsedRider = JSON.parse(riderData.value);
                                const riderDetails = parsedRider?.delivery_info?.delivery_person_details;
                                return (
                                  <>
                                    {riderDetails?.name && riderDetails.name !== "Unknown" && (
                                      <Row style={{ marginTop: "1vh" }}>
                                        <Col
                                          span={9}
                                          style={{
                                            fontWeight: 400,
                                            fontSize: "0.9em",
                                            color: "#0F0718",
                                            fontFamily: "Inter",
                                          }}
                                        >
                                          Rider Name
                                        </Col>
                                        <Col
                                          span={15}
                                          style={{
                                            fontWeight: 500,
                                            fontSize: "1.1em",
                                            color: "#0F0718",
                                            fontFamily: "Inter",
                                          }}
                                        >
                                          {riderDetails.name}
                                        </Col>
                                      </Row>
                                    )}
                                    {riderDetails?.phone && riderDetails.phone !== "N/A" && (
                                      <Row style={{ marginTop: "1vh" }}>
                                        <Col
                                          span={9}
                                          style={{
                                            fontWeight: 400,
                                            fontSize: "0.9em",
                                            color: "#0F0718",
                                            fontFamily: "Inter",
                                          }}
                                        >
                                          Rider Phone No
                                        </Col>
                                        <Col
                                          span={15}
                                          style={{
                                            fontWeight: 500,
                                            fontSize: "1.1em",
                                            color: "#0F0718",
                                            fontFamily: "Inter",
                                          }}
                                        >
                                          {riderDetails.phone}
                                        </Col>
                                      </Row>
                                    )}
                                    {parsedRider?.delivery_info?.current_state && (
                                      <Row style={{ marginTop: "1vh" }}>
                                        <Col
                                          span={9}
                                          style={{
                                            fontWeight: 400,
                                            fontSize: "0.9em",
                                            color: "#0F0718",
                                            fontFamily: "Inter",
                                          }}
                                        >
                                          Rider Status
                                        </Col>
                                        <Col
                                          span={15}
                                          style={{
                                            fontWeight: 500,
                                            fontSize: "0.8em",
                                            color: "#0F0718",
                                            fontFamily: "Inter",
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          <p
                                            style={{
                                              backgroundColor: "#4F23F1",
                                              color: "#fff",
                                              borderRadius: "3px",
                                              padding: "3px 8px",
                                              marginBottom: 0,
                                            }}
                                          >
                                            {parsedRider.delivery_info.current_state}
                                          </p>
                                        </Col>
                                      </Row>
                                    )}
                                  </>
                                );
                              } catch (e) {
                                console.error("Failed to parse rider metadata:", e);
                                return null;
                              }
                            })()}
                          </>
                        )}

                        {selectedOrder.metaData.some((md) => md.key === "Instructions") && (
                          <>
                            <Row style={{ marginTop: "2vh" }}>
                              <Col
                                span={24}
                                style={{
                                  fontWeight: 600,
                                  fontSize: "1.2em",
                                  color: "#2F3856",
                                  fontFamily: "Inter",
                                }}
                              >
                                Order Instructions
                              </Col>
                            </Row>
                            <Row style={{ marginTop: "1vh" }}>
                              <Col
                                span={24}
                                style={{
                                  fontWeight: 400,
                                  fontSize: "0.9em",
                                  color: "#0F0718",
                                  fontFamily: "Inter",
                                  wordBreak: "break-word",
                                  maxHeight: "10vh",
                                  overflowY: "auto",
                                }}
                              >
                                {selectedOrder.metaData.find((md) => md.key === "Instructions")?.value || "N/A"}
                              </Col>
                            </Row>
                          </>
                        )}
                      </>
                    )}
                  </Col>
                </Row>

                <Table
                  className="sm-aggregator-table"
                  style={{
                    marginTop: "2vh",
                    border: "1px solid rgba(146, 144, 152, 0.4)",
                    borderRadius: "7px",
                    padding: "7px",
                    background: "#fff",
                    maxHeight: "30vh",
                  }}
                  id="sm-view-order-table"
                  pagination={false}
                  scroll={{ y: "25vh" }}
                  dataSource={getTableData(selectedOrder)}
                  columns={[
                    { title: "Item Name", dataIndex: "product", width: "40%" },
                    { title: "Qty", dataIndex: "grossstd", width: "15%" },
                    { title: "Discount", dataIndex: "qty", width: "15%" },
                    { title: "Tax", dataIndex: "remainingQty", width: "15%" },
                    { title: "Price", dataIndex: "linenet", width: "20%" },
                    { title: "Total", dataIndex: "netValue", width: "15%" },
                  ]}
                />
              </div>

              <div
                style={{
                  padding: "1.5vh 1.2vw",
                  borderTop: "1px solid rgba(146, 144, 152, 0.4)",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                {renderButtons()}
              </div>
            </div>
          ) : (
            <div
              style={{
                backgroundColor: "#fff",
                height: "78vh",
                borderRadius: "7px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <p>No order selected</p>
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default Aggregator;